var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArticulation = function SvgArticulation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    d: "M7 22.5v-2.298a2 2 0 0 1 .438-1.25L9 17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    d: "m3 12.5.682 1.704a2 2 0 0 0 1.114 1.114l5.66 2.265a2 2 0 0 0 1.943-.257l.445-.334a1.64 1.64 0 0 0 .656-1.312v0c0-.435.173-.853.48-1.16l.08-.08a.957.957 0 0 0-.248-1.534l-1.47-.735a.62.62 0 0 1-.342-.553v0c0-.341.277-.618.618-.618h1.69c.658 0 1.192-.534 1.192-1.193v0c0-.487.297-.926.75-1.107l.74-.296a1 1 0 0 0 .524-1.376l-1.803-3.606a2 2 0 0 1-.211-.894V1M18.016 14.53a2.143 2.143 0 0 0 0-3.03M20.531 16.046a4.286 4.286 0 0 0 0-6.062"
  })));
};
export default SvgArticulation;